import { render, staticRenderFns } from "./View.vue?vue&type=template&id=912f3bec"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('912f3bec')) {
      api.createRecord('912f3bec', component.options)
    } else {
      api.reload('912f3bec', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=912f3bec", function () {
      api.rerender('912f3bec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/retenciones/View.vue"
export default component.exports